import React, {useEffect} from 'react';
import {Dropdown} from 'semantic-ui-react';

import {Icon} from '../Icon';
import {
  DropdownDivider,
  DropdownItem,
  DropdownItemLeftWrapper,
  StyledPermissionDropdown,
} from './Dropdown.styles';

export const INDIVIDUAL_SHARING_REVOKE_VALUE = 'revoke';

const MEDIUM_BUTTON_HEIGHT = 32;

export const PermissionDropdown = ({
  selectedValue,
  options,
  Trigger,
  onItemClick,
  id,
  onClose,
  setIsOpen,
  isOpen,
}: {
  selectedValue: string;
  options: any[];
  Trigger: React.ReactChild;
  onItemClick: (val: string) => void;
  id: string;
  onClose: () => void;
  isOpen: boolean;
  setIsOpen: (s: string) => void;
}) => {
  // All this logic is used to set the dropdown as a fixed element
  // so it is visible past the scrollable container in the modal
  const scrollContentEl = document.getElementById(
    'share-modal-user-email-scroll-content'
  );
  const menuWrapperBounds = document
    .getElementById(`permissionMenuWrapper-${id}`)
    ?.getBoundingClientRect();

  const shareReportModalBounds = document
    .getElementById('share-report-modal')
    ?.getBoundingClientRect();

  const menuEl = document.getElementById(`permissionMenu-${id}`);
  if (menuEl !== null && menuWrapperBounds && shareReportModalBounds) {
    menuEl.style.top = `${
      menuWrapperBounds.top - shareReportModalBounds.top + MEDIUM_BUTTON_HEIGHT
    }px`;
  }

  const hasScrollBar =
    scrollContentEl !== null &&
    scrollContentEl.offsetWidth > scrollContentEl.clientWidth;

  useEffect(() => {
    scrollContentEl?.addEventListener(
      'scroll',
      () => {
        // this closes the dropdown on scroll
        onClose();
        setIsOpen('');
      },
      {
        capture: true,
        passive: true,
      }
    );
    return scrollContentEl?.removeEventListener('scroll', () => {});
  }, [scrollContentEl, onClose, setIsOpen]);

  return (
    <StyledPermissionDropdown
      id={`permissionMenuWrapper-${id}`}
      direction="left"
      icon={<></>}
      trigger={Trigger}
      open={isOpen}
      onClose={onClose}
      $hasScrollbar={hasScrollBar}>
      <Dropdown.Menu id={`permissionMenu-${id}`}>
        {options.map((opt, idx) =>
          opt.value === 'divider' ? (
            <DropdownDivider key={`divider-${idx}`} />
          ) : (
            <DropdownItem
              key={opt.value}
              $destructive={opt.destructive}
              $selected={selectedValue === opt.value}
              onClick={() => onItemClick(opt.value)}>
              <DropdownItemLeftWrapper>
                <Icon name={opt.icon} />
                {opt.name}
              </DropdownItemLeftWrapper>
              {opt.value !== INDIVIDUAL_SHARING_REVOKE_VALUE && (
                <Icon name="checkmark" className="checkIcon" />
              )}
            </DropdownItem>
          )
        )}
      </Dropdown.Menu>
    </StyledPermissionDropdown>
  );
};
